import { MapPin, Leaf, CalendarDays } from "lucide-react";
import type { FavoriteKind } from "@/lib/favorites/types";

const FALLBACK_ICON: Record<FavoriteKind, React.ElementType> = {
  place: MapPin,
  producer: Leaf,
  activity: CalendarDays,
};

interface FavoriteLeadingMediaProps {
  kind: FavoriteKind;
  imageUrl: string | null | undefined;
  alt?: string;
  size?: number;
}

export function FavoriteLeadingMedia({
  kind,
  imageUrl,
  alt = "",
  size = 48,
}: FavoriteLeadingMediaProps) {
  const Icon = FALLBACK_ICON[kind] ?? MapPin;

  return (
    <div
      className="shrink-0 rounded-lg overflow-hidden bg-muted"
      style={{ width: size, height: size }}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={alt}
          loading="lazy"
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center">
          <Icon className="h-5 w-5 text-muted-foreground/50" />
        </div>
      )}
    </div>
  );
}
